import { render } from "./CardsWhy.vue?vue&type=template&id=790106cf&scoped=true&ts=true"
import script from "./CardsWhy.vue?vue&type=script&lang=ts"
export * from "./CardsWhy.vue?vue&type=script&lang=ts"

import "./CardsWhy.vue?vue&type=style&index=0&id=790106cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790106cf"]])

export default __exports__